import i from "react";
import { IconButton as E, Typography as o, TextField as x, InputAdornment as b } from "@mui/material";
import { I as c, a as m } from "./chunk.zlc_6vey.js";
import { c as T } from "./chunk.DsbGl_E4.js";
import { g as y } from "./chunk.CKXGCgA0.js";
function S(n = "text", l) {
  return n === "number" && !/^-?[0-9]+((\.|,)[0-9]*)?$/.test(l) && l !== "" && l !== "-";
}
function z(n, l, t) {
  if (l) {
    const r = {
      icon: l.icon,
      variant: l.iconVariant
    };
    return /* @__PURE__ */ i.createElement(
      E,
      {
        "aria-label": l.icon,
        onClick: () => l.onClick && l.onClick(),
        edge: "end",
        disabled: n
      },
      /* @__PURE__ */ i.createElement(c, { ...r })
    );
  } else if (t)
    return m.includes(t) ? /* @__PURE__ */ i.createElement(c, { icon: t }) : /* @__PURE__ */ i.createElement(o, null, t);
}
const W = ({
  startAdornment: n,
  endAdornment: l,
  endIconButton: t,
  maxLength: r,
  inputType: u,
  inputProps: d,
  InputProps: f,
  size: s = "default",
  ...e
}) => {
  function g(a) {
    if (m.includes(a))
      return /* @__PURE__ */ i.createElement(
        c,
        {
          "aria-label": a,
          sx: { color: T.typography.lowEmphasis },
          icon: a
        }
      );
    if (a)
      return /* @__PURE__ */ i.createElement(o, null, a);
  }
  const p = y(s);
  return /* @__PURE__ */ i.createElement(
    x,
    {
      id: e.id,
      name: e.name,
      "data-testid": e["data-testid"],
      label: e.label,
      helperText: e.helperText,
      error: e.error,
      required: e.required,
      disabled: e.disabled,
      fullWidth: e.fullWidth,
      onError: e.onError,
      variant: "outlined",
      size: p,
      InputProps: {
        ...f,
        startAdornment: n && /* @__PURE__ */ i.createElement(b, { position: "start" }, g(n))
      },
      inputProps: {
        ...d,
        maxLength: r || null,
        ...u === "number" && {
          type: "text",
          inputMode: "decimal"
        }
      },
      onChange: (a) => {
        if (e.onInputChange) {
          if (S(u, a.target.value))
            return;
          e.onInputChange(a);
        }
      },
      value: e.inputValue,
      onBlur: e.onBlur,
      autoFocus: e.autoFocus,
      placeholder: e.placeholder
    }
  );
};
export {
  W as T,
  z as g,
  S as i
};
